module.exports = __webpack_public_path__ + "static/media/euparl.a58b898a.jpg";